:global(.bi-sub-navbar--wrapper):has(.programmePageNavigation) {
    height: 0;
}

.programmePageNavigation {
    &:not([data-fixed='true']) {
        display: none;
    }

    > div {
        max-width: 1128px;
        margin: 0 auto;
        display: flex;
        gap: var(--bi-scale-1x);
        justify-content: space-between;
        align-items: center;
        padding: var(--bi-scale-1x) 0;

        @media (max-width: 1128px) {
            padding: var(--bi-scale-1x) var(--bi-scale-4x) var(--bi-scale-1x) var(--bi-scale-1x);
        }

        .trigger {
            max-width: 368px;
            justify-content: space-between;
            flex: 1;
            padding: var(--bi-scale-2x) var(--bi-scale-5x);

            @media (max-width: 768px) {
                padding: var(--bi-scale-2x) var(--bi-scale-3x);
            }

            .triggerIcon {
                transition: rotate 0.2s;
            }

            &[aria-expanded='true'] {
                .triggerIcon {
                    rotate: 180deg;
                }
            }

            > span:first-of-type {
                overflow: hidden;

                > span {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    display: block;
                    margin-bottom: calc(var(--bi-scale-0-50x) * -1);

                    &:first-of-type {
                        font: var(--bi-font-label-small);
                        color: var(--bi-primary-20);
                    }
                }
            }
        }

        .dropdown {
            --bic-dropdown-background: var(--bi-primary-5);
            --bic-dropdown-padding: 0;
            --bic-dropdown-border-width: 0;
            --dropdown-border-radius: 0 0 var(--bi-scale-11x) 0;
            border-radius: var(--dropdown-border-radius);
            margin-top: var(--bi-scale-1x);

            @media (max-width: 450px) {
                --bic-dropdown-min-width: 100dvw;
            }

            > ul {
                gap: 0;

                > li {
                    > hr {
                        margin: 0;
                        border: none;
                        border-top: 1px solid var(--bi-primary-10);
                        opacity: 0.5;
                    }

                    &:has(> .dropdownButton[aria-current='true']) {
                        background: var(--bi-primary-15);
                    }

                    > .dropdownButton {
                        font-weight: var(--bi-font-weight-regular);
                        padding: var(--bi-scale-2x) var(--bi-scale-4x) var(--bi-scale-2x) var(--bi-scale-4x);
                        border-left: var(--bi-scale-1x) solid transparent;
                        border-radius: 0;
                        color: var(--bi-primary-90);

                        @media (max-width: 768px) {
                            padding-left: var(--bi-scale-2x);
                        }

                        @media (max-width: 450px) {
                            padding-left: var(--bi-scale-3x);
                        }

                        &[aria-current='true'] {
                            border-left-color: var(--bi-primary-50);
                        }
                    }

                    &:last-of-type {
                        border-bottom: none;
                        border-radius: var(--dropdown-border-radius);
                        > .dropdownButton {
                            border-radius: var(--dropdown-border-radius);
                        }
                    }
                }
            }
        }
    }
}
